import { useEffect } from "react";
import { useSelector } from "react-redux";
import { Outlet } from "react-router-dom";
import SplashScreen from "src/components/SplashScreen/SplashScreen";
import useGetModules from "src/hooks/useGetModules";
import useAuthFlow from "src/auth/useAuthFlow";
import useParentLanguageListener from "src/auth/useParentLanguageListener";
import IntegratedAuthFailed from "src/auth/IntegratedAuthFailed";
import { setAmplitudeUser } from "src/Analytics/Amplitude";
import { RootState } from "src/store";
import useGetClientTheme from "src/hooks/useGetClientTheme";
import useGetUser from "src/hooks/useGetUser";

export default function AppInitializer() {
  const { flow, isFetching: isAuthFetching } = useAuthFlow();
  const { isFetching: isModulesFetching } = useGetModules();
  const {isFetching:isUserFetching} = useGetUser();
  const {isFetching:isThemeFetching} = useGetClientTheme();
  useParentLanguageListener();
  const isFetching = isAuthFetching || isModulesFetching || isThemeFetching;
  const user = useSelector((state: RootState) => state.auth.user);
  const tenantId = useSelector((state: RootState) => state.auth.tenantId);
  const token = useSelector((state: RootState) => state.auth.token);

  useEffect(() => {
    if (!user) return;

    setAmplitudeUser({
      id: user.userName,
      name: user.Name,
      email: user.Email,
      role: user.role,
      phoneNumber: user.PhoneNumber,
      tenantId: tenantId ?? undefined,
    });
  }, [user, tenantId]);

  if (isFetching) {
    return (
      <div className="flex w-full items-center justify-center">
        <SplashScreen isLoading />
      </div>
    );
  }

  if (flow === "integrated" && !token) {
    return <IntegratedAuthFailed />;
  }

  return <Outlet />;
}
